export enum CURRENT_PLAN {

    VISITOR= "visitor",
    REGISTERED= "registered",
    TRIAL= "trial",
    ESSENTIAL= "essential",
    ESSENTIAL_IN_CART= "essential_in_cart",
    PREMIER= "premier",
    PREMIER_IN_CART= "premier_in_cart",
    ENTERPRISE = "enterprise",
    ENTERPRISE_IN_CART = "enterprise_in_cart",
    ENTERPRISE_M2M = "enterprise_m2m",
    ENTERPRISE_M2M_IN_CART = "enterprise_m2m_in_cart",
    LEGACY_PERP = "legacy_perp",
    LEGACY_LOANED = "legacy_loaned",
    NFR = "nfr",
    HCMS = "hcms",
    HIBERNATE = "hibernate",
    HIBERNATE_FREE = "hibernate_free",
    HIBERNATE_CANCELED = "hibernate_canceled",
    HIBERNATE_IN_CART = "hibernate_in_cart",
    PLAYER_ONLY = "player_only",
    CONTACT_US = "contact_us",
    INACTIVE = "inactive"
    
}

